import React, { useContext } from "react";

import { apiResolveStr } from "../../../../../../apiBindings";
import { DataContext } from "../../../../../../providers/GasCheckoutDataProvider";
import Checkbox from "../../../../../shared/forms/Checkbox";
import FormError from "../../../../../shared/forms/FormError";
import * as styles from "./style.module.scss";

const Agb = () => {
    const dataContext = useContext(DataContext);

    const { agbChecked } = dataContext.data;
    const { setAgbChecked, hasFormErrorAt } = dataContext.actions;

    return (
        <React.Fragment>
            <div className={styles.checkboxRow}>
                <div>
                    <Checkbox
                        className={styles.checkbox}
                        checked={agbChecked}
                        onClick={() => {
                            setAgbChecked(!agbChecked);
                        }}
                    />
                </div>
                <div className={styles.checkboxLabel}>
                    <span>
                        Ich erkenne die{" "}
                        <a
                            target="_blank"
                            href={apiResolveStr(
                                "/files/Allgemeine_Geschaeftsbedingungen_Erdgas.pdf"
                            )}
                            rel="noreferrer"
                        >
                            AGB
                        </a>{" "}
                        an und habe die{" "}
                        <a
                            target="_blank"
                            href={apiResolveStr(
                                "/files/Widerrufsbelehrung_Strom_Erdgas.pdf"
                            )}
                            rel="noreferrer"
                        >
                            Widerrufsbelehrung
                        </a>{" "}
                        gelesen.
                    </span>
                </div>
            </div>
            {hasFormErrorAt("agb") && (
                <FormError message="Bitte akzeptieren sie die AGB." />
            )}
        </React.Fragment>
    );
};

export default Agb;
